// extracted by mini-css-extract-plugin
export default {"FeatureItem":"Feature_FeatureItem__KgI8S","FeatureItemImg":"Feature_FeatureItemImg__L8mF+","FeatureItemText":"Feature_FeatureItemText__bnS5g"};